import { FaCopy, FaQrcode, FaStar } from 'react-icons/fa';

const Gift = () => {
  const bankAccounts = [
    {
      bank: 'En sobre',
      name: 'A la atención de Raquel o Daniel',
      number: '',
      favorite: true,
      isBank: false
    },
    {
      bank: 'N26 (Alemania)',
      name: 'Daniel García González',
      number: 'DE79 **** **** **** 8229',
      favorite: true,
      isBank: true
    },
    {
      bank: 'ING',
      name: 'Raquel Huete Campos',
      number: '',
      favorite: false,
      isBank: true
    },
  ];

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-2xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-6">Sobre Digital</h2>
        
        <p className="text-center text-gray-600 mb-8">
          Para quienes quieran mandarnos una muestra de cariño
        </p>
        
        <div className="space-y-6">
          {bankAccounts.map((account, index) => (
            <div key={index} className="bg-rose-50 p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-rose-600 mb-3">{account.bank} { account.favorite ? <FaStar className="inline-block ml-1" /> : undefined }</h3>
              <div className="space-y-2">
                <p>{ account.isBank ? 'Nombre: ' : '' }<span className="font-medium">{account.name}</span></p>
                <div className="flex justify-between items-center">
                  <p>{ account.isBank ? 'No. de cuenta: ' : '' } <span className="font-medium">{account.number}</span></p>
                  <button 
                    onClick={() => copyToClipboard(account.number.replace(/\s/g, ''))}
                    className="text-rose-600 hover:text-rose-700 flex items-center gap-1 text-sm"
                  >
                    { account.isBank ? <FaCopy />  : ''}
                    { account.isBank ? ' Copiar'  : ''}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-8 bg-rose-50 p-6 rounded-lg shadow-sm text-center">
          <h3 className="text-xl font-semibold text-rose-600 mb-4">QR</h3>
          <div className="flex justify-center mb-4">
            <div className="bg-white p-4 rounded-lg inline-flex items-center justify-center">
              <FaQrcode className="text-6xl text-gray-400" />
            </div>
          </div>
          <button className="px-4 py-2 bg-rose-600 text-white rounded-lg hover:bg-rose-700 transition-colors flex items-center gap-2 mx-auto">
            <FaQrcode /> Ver código QR
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gift;